import React from "react";


export const CardEventosProximos = (props) =>{
    return(              
        <div className="card d-flex align-items-center justify-content-center card-eventop" style={{width: '18rem'}}>
        <div className="imgen-card-container d-flex align-items-center justify-content-center">
            <div className="imgen-content">
                <img id={'id-img-evenp-' + props.idx} loading="lazy" className= "imagen-evento foto-eventop card-img-top" src={props.foto ? props.foto : require('../../assets/fotos/unknown.png') } alt="evento" />
            </div>
            
        </div>
        <div className="card-body bg-blue d-flex align-items-center justify-content-cente flex-column">
            <h5 className="card-title name-evenp text-center">{props.name} </h5>
            <p className="card-text linea-evenp">{props.uni}</p>
            <small className="card-text text-center linea-inv-text">{props.linea}</small>
        </div>
    </div>
    ) 
}

